
<div class="ttmodal__header" style="margin-bottom: 15px">
  <span class="ttmodal__title" style="font-size: 20px;">Set Column Order</span>
  <i class="material-icons ttmodal__close-button" style="cursor: pointer;float: right;" (click)="onCloseClick()">close</i>

</div> 

<div class="dialog">
  
  

  <mat-list class="header-form-full-width"  >
    <mat-list-item *ngFor="let column of displayedColumns_; let i = index"  >  
      <span matLine>{{column == 'condition'? 'Worn': column}}        
     </span>
     <div style="display: flex;">               
      <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="moveDown(i)"
      [class.button-hide]="isLastComponentInList(column, i)">arrow_downward</mat-icon>
      <mat-icon style="vertical-align: middle; cursor: pointer;" (click)="moveUp(i)" 
      [class.button-hide]="isFirstComponentInList(column, i)">arrow_upward</mat-icon>     
     </div>
    </mat-list-item> 
  </mat-list>


  <!-- <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
    <button (click)="onCloseClick()" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
      >Update</span></button>
    
  </div> -->

</div>
